module.exports = __webpack_public_path__ + "static/media/pmbrc.7fc3acca.jpg";